import React, { Component } from "react";
import "./styles.scss";

export class AdminNotesModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adminNotes: "",
    };
    this.handleNotesChange = this.handleNotesChange.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleNotesChange(event) {
    this.setState({ adminNotes: event.target.value });
  }

  handleConfirm() {
    const { adminNotes } = this.state;
    this.props.onConfirm(adminNotes || null);
    this.setState({ adminNotes: "" });
  }

  handleCancel() {
    this.setState({ adminNotes: "" });
    this.props.onCancel();
  }

  render() {
    const { isOpen, actionType, requestDescription } = this.props;
    const { adminNotes } = this.state;

    if (!isOpen) {
      return null;
    }

    const isApprove = actionType === "approve";
    const actionTitle = isApprove ? "Approve" : "Decline";
    const actionClass = isApprove ? "btn-primary" : "btn-danger";

    return (
      <div className="admin-notes-modal-overlay">
        <div className="admin-notes-modal">
          <div className="modal-header">
            <h4 className="modal-title">{actionTitle} Request</h4>
            <button
              type="button"
              className="close"
              onClick={this.handleCancel}
              aria-label="Close"
            >
              &times;
            </button>
          </div>
          <div className="modal-body">
            {requestDescription && (
              <div className="request-description">
                <strong>Request:</strong> {requestDescription}
              </div>
            )}
            <div className="form-group">
              <label htmlFor="adminNotes">Add notes (optional):</label>
              <textarea
                id="adminNotes"
                className="form-control"
                rows="4"
                maxLength="1000"
                placeholder="Enter notes for this action..."
                value={adminNotes}
                onChange={this.handleNotesChange}
              />
              <small className="form-text text-muted">
                {adminNotes.length}/1000 characters
              </small>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={this.handleCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className={`btn ${actionClass}`}
              onClick={this.handleConfirm}
            >
              {actionTitle}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
